import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgConsole = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.728 9.405a.662.662 0 0 0-1.325 0v1.086H6.317a.662.662 0 1 0 0 1.323h1.086v1.085a.662.662 0 0 0 1.325 0v-1.085h1.086a.662.662 0 1 0 0-1.323H8.728zM17.246 10.816h.002a1.036 1.036 0 1 0-.002 0M13.961 12.026v.023a1.036 1.036 0 0 0 2.074-.023v-.023a1.036 1.036 0 0 0-2.074.023"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.65 9.623A5.2 5.2 0 0 1 7.82 5h8.36a5.2 5.2 0 0 1 5.17 4.623l.624 5.61a4.115 4.115 0 0 1-4.091 4.567c-1.56 0-2.986-.88-3.683-2.274l-.36-.72h-3.68l-.36.72A4.12 4.12 0 0 1 6.118 19.8a4.115 4.115 0 0 1-4.092-4.568zm5.17-3.3A3.877 3.877 0 0 0 3.966 9.77l-.624 5.609a2.793 2.793 0 0 0 5.274 1.556l.544-1.087a.66.66 0 0 1 .592-.366h4.496c.251 0 .48.142.593.366l.543 1.087a2.793 2.793 0 0 0 5.274-1.556l-.624-5.61a3.877 3.877 0 0 0-3.854-3.446z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgConsole;
